import React from 'react';

export default function ModalContent({children}: React.PropsWithChildren<any>) {
  return (
    <div className="mt-2">
      {children}
    </div>
  );
}
